
import { Component, Prop, Model, Vue } from 'vue-property-decorator';

@Component
export default class Checkbox extends Vue {
  @Prop() label!: string;
  @Model('input', { type: Boolean }) readonly value!: boolean;
}
